/**
 * Define the max value taking into account masking
 * @param masking
 * @param maxLength
 */
export const maxValue = (masking, maxLength) => {
  return masking && masking.maskedMaxLength || maxLength;
};